export default __webpack_public_path__ + "static/media/gsi_badge.9ee1541d.png";